function create(...filters) {
  filters = filters.map(filter => {
    if(filter.type != 'and') {
      return include(filter)
    } else return filter
  })
  return {
    "type": "and",
    args: filters
  }
}

function include(...filters) {
  filters = filters.map(filter => {
    if(filter.type != 'or') {
      return {
        "type": "or",
        args: [filter]
      }
    } else return filter
  })
  return {
    type: "and",
    args: filters
  }
}

function exclude(...filters) {
  filters = filters.map(filter => {
    if(filter.type != 'or') {
      return {
        "type": "or",
        args: [filter]
      }
    } else return filter
  })
  return {
    type: "nand",
    args: filters
  }
}

function and(...filters) {
  return {
    type: "and",
    args: filters
  }
}

function or(...filters) {
  return {
    type: "or",
    args: filters
  }
}

function gt(columnName, value) {
  return {
    "type": ">",
    "args": [
      columnName,
      value
    ]
  }
}

function lt(columnName, value) {
  return {
    "type": "<",
    "args": [
      columnName,
      value
    ]
  }
}

function eq(columnName, value) {
  return {
    "type": "=",
    "args": [
      columnName,
      value
    ]
  }
}

export default {
  create, include, exclude, and, or, gt, lt, eq
}



// WEBPACK FOOTER //
// ./src/logic/filterGenerator.js